import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* Original name @uswitch/trustyle.hero-with-background-image */
import { useThemeUI } from 'theme-ui';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var HeroWithBackgroundImage = function HeroWithBackgroundImage(_ref) {
  var _heroTheme$background;

  var children = _ref.children,
      imageUrl = _ref.imageUrl,
      className = _ref.className;

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  var heroTheme = theme.modules['hero-with-background-image'];
  var opacity = heroTheme && ((_heroTheme$background = heroTheme['background-image']) === null || _heroTheme$background === void 0 ? void 0 : _heroTheme$background.opacity);
  var backgroundImgSx = {
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundImage: "url(".concat(imageUrl, ")")
  }; // insert pseudo element only if opacity is defined

  var imgSx = opacity ? {
    position: 'relative',
    '::before': _objectSpread({
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      position: 'absolute',
      content: "''",
      opacity: opacity,
      zIndex: -100
    }, backgroundImgSx)
  } : backgroundImgSx;
  return _jsx("div", {
    sx: _objectSpread(_objectSpread({}, imgSx), {}, {
      variant: 'modules.hero-with-background-image'
    }),
    className: className,
    children: children
  });
};

export default HeroWithBackgroundImage;
//# sourceMappingURL=index.js.map